import { useQuery } from "@tanstack/react-query";
import { useApi } from "hooks/useApi";

const useGetSignedImageUrl = (publicUrl: string | null) => {
  const callApi = useApi();

  return useQuery({
    queryKey: ["signedImageUrl", publicUrl],
    queryFn: () => callApi(`/${publicUrl}`).then((response) => response?.data?.[0].url || ""),
    enabled: !!publicUrl?.startsWith("/"),
    staleTime: 30000,
  });
};

export default useGetSignedImageUrl;
